import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  CONSENT_TEMPLATE_NORMALIZER,
  UserConsentConnector as CxUserConsentConnector,
  OccEndpointsService,
  UserConsentAdapter,
} from '@spartacus/core';
import { Observable } from 'rxjs';
import { ConsentTemplate } from '../../model';
import { Occ } from '../../occ';
import { ConverterService } from '../../util';

@Injectable({
  providedIn: 'root',
})
export class UserConsentConnector extends CxUserConsentConnector {
  constructor(
    protected adapter: UserConsentAdapter,
    protected http: HttpClient,
    protected occEndpoints: OccEndpointsService,
    protected converter: ConverterService
  ) {
    super(adapter);
  }

  denyConsent(userId: string, consentTemplateId: string, consentTemplateVersion: number): Observable<ConsentTemplate> {
    const url = this.occEndpoints.buildUrl('consentDenial', { urlParams: { userId, consentTemplateId, consentTemplateVersion } });
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
    });
    return this.http.post<Occ.ConsentTemplate>(url, {}, { headers }).pipe(this.converter.pipeable(CONSENT_TEMPLATE_NORMALIZER));
  }
}
